import { render } from "./whr-project-page-single.vue?vue&type=template&id=593c6ab4&scoped=true"
import script from "./whr-project-page-single.vue?vue&type=script&lang=js"
export * from "./whr-project-page-single.vue?vue&type=script&lang=js"

import "./whr-project-page-single.vue?vue&type=style&index=0&id=593c6ab4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-593c6ab4"]])

export default __exports__